import { render } from "./FullCourseBuilder.vue?vue&type=template&id=339bc33e&scoped=true"
import script from "./FullCourseBuilder.vue?vue&type=script&lang=js"
export * from "./FullCourseBuilder.vue?vue&type=script&lang=js"

import "./FullCourseBuilder.vue?vue&type=style&index=0&id=339bc33e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339bc33e"]])

export default __exports__